import React from 'react';
import { Printer } from 'lucide-react';

const PrintExportButtons = ({ className = '' }) => {
  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const currentDate = new Date().toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    // Obtener el elemento a imprimir
    let printContent = document.querySelector('.pme-list').cloneNode(true);
    
    // Crear el HTML para impresión
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Reporte PME</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
              margin: 0;
              padding: 20px;
              width: 100%;
              box-sizing: border-box;
            }

            h1 {
              color: #5664D2;
              margin-bottom: 2rem;
              font-size: 16px;
            }

            .footer {
              position: fixed;
              bottom: 0;
              left: 1.5cm;
              right: 1.5cm;
              padding: 10px 0;
              border-top: 1px solid #ddd;
              font-size: 10px;
              color: #666;
              background-color: white;
              display: flex;
              justify-content: center;
            }

            @media print {
              .monitoreo-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 1rem;
                font-size: 12px;
              }

              .monitoreo-table th,
              .monitoreo-table td {
                border: 1px solid #ddd;
                padding: 6px 8px;
                text-align: left;
              }

              .monitoreo-table td:last-child {
                text-align: center;
                vertical-align: middle;
                padding: 0.5rem;
                min-width: 80px;
              }

              .monitoreo-table th {
                background-color: #5664D2 !important;
                color: white !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              .year-section {
                margin-bottom: 1.5rem;
                page-break-inside: avoid;
              }

              .year-section p {
                background-color: #5664D2 !important;
                color: white !important;
                padding: 6px 12px;
                border-radius: 8px;
                display: inline-block;
                font-size: 12px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              .totals-row {
                background-color: rgba(86, 100, 210, 0.1) !important;
                font-weight: bold;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              .compliance-indicator-circle {
                transform: scale(1);
                display: inline-flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
              }

              .compliance-indicator-circle svg {
                width: 45px !important;
                height: 45px !important;
                display: block;
                margin: 0 auto;
              }

              @page {
                size: landscape;
                margin: 1.5cm;
                margin-bottom: 2.5cm;
              }

              .footer {
                position: fixed;
                bottom: 0;
              }
            }
          </style>
        </head>
        <body>
          <h1>Reporte de Cumplimiento PME</h1>
          <div id="print-content">
            ${printContent.outerHTML}
          </div>
          <div class="footer">
            <span>Informe creado: ${currentDate}</span>
          </div>
          <script>
            window.onload = () => {
              setTimeout(() => {
                window.print();
                window.onafterprint = () => window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
  };

  return (
    <button
      onClick={handlePrint}
      className='btn-inform flex'
    >
      <Printer color="white" size={20} />
      <p>Imprimir Reporte</p>
    </button>
  );
};

export default PrintExportButtons;